import { IField } from 'shared/entities/form';

export const EVENT_PREFIX_FOR_SECONDARY_COUNTER = 'auth';

export interface IAnalytics {
  initialize(): void;
  reset(): void;
  addToQueue(event: AnalyticsEventObj): void;
  initialized: IField<boolean | null>;
}

export interface IYandexAnalytics extends IAnalytics {
  getId(): Promise<BaseResponse<string>>;
}

export interface IRoistatAnalytics extends IAnalytics {
  readonly id: IField<string | null>;
}

export enum AnalyticsEvent {
  authRegistrationOk = 'auth_registration_ok',
  authRegistrationError = 'auth_registration_error',
  authCabinetCreationOk = 'auth_cabinet_creation_ok',
  authRegistrationPageView = 'auth_registration_page_view',
  authClickVkAuth = 'auth_click_vk_auth',
  authClickELamaAuth = 'auth_click_elama_auth',
  authClickGoogleAuth = 'auth_click_google_auth',
  authClickTgAuth = 'auth_click_tg_auth',
  authNeedExtraData = 'auth_need_extra_data',
  authAddedExtraData = 'auth_added_extra_data',

  scenarioCreationOk = 'scenario_creation_ok',

  channelCreationOk = 'channel_creation_ok',
  channelCreationViaJivoOk = 'channel_creation_via_jivo_ok',
  channelCreationViaWazzupOk = 'channel_creation_via_wazzup_ok',

  templateOpenModal = 'template_open_modal',
  templateApply = 'template_apply',
  templateOpen = 'template_open',
  notFoundDesiredTemplate = 'not_found_desired_template',

  paymentOpenKassa = 'payment_open_kassa',
  paymentSuccess = 'payment_success',
  paymentSuccessYm = 'payment_success_ym',
  paymentSuccessSubscriptionAvailable = 'payment_success_subscription_available',
  paymentSubscriptionActivation = 'payment_subscription_activation',
  paymentSuccessFirst = 'payment_success_first',
  balancePageView = 'balance_page_view',
  paymentButtonClick = 'payment_button_click',
  manageTariffButtonClick = 'manage_tariff_button_click',
  raiseTariffFromRecommendationClick = 'raise_tariff_from_recommendation_click',
  paymentBalance = 'payment_balance', // клик на кнопку "Оплатить картой"
  payByInvoiceClick = 'pay_by_invoice_click',
  changeTariffAndPayByCardClick = 'change_tariff_and_pay_by_card_click',
  changeTariffAndPayByInvoiceClick = 'change_tariff_and_pay_by_invoice_click',
  changeTariffWithoutPaymentClick = 'change_tariff_without_payment_click',
  tariffSelectClick = 'tariff_select_click',

  linkToVkClick = 'link_to_vk_click',
  linkToTgClick = 'link_to_tg_click',
  linkToSmartbotBlogClick = 'link_to_smartbot_blog_click',
  linkToVcRuClick = 'link_to_vc_ru_click',

  statsOnBlock = 'stats_on_block',

  projectUnitClick = 'project_unit_click',

  shopbackCreateProject = 'shopback_create_project',
  shopbackCreateCategory = 'shopback_create_category',
  shopbackCreateProduct = 'shopback_create_product',

  smartbotAIBotCreate = 'smartbot_ai_bot_create',
  smartbotAIBotUpdate = 'smartbot_ai_bot_update',
  smartbotAIBotTest = 'smartbot_ai_bot_test',
  smartbotAIBotConnectionPageView = 'smartbot_ai_bot_connection_page_view',
  smartbotAIBotInstructionPageView = 'smartbot_ai_bot_instruction_page_view',
  smartbotAIChannelsModalOpen = 'smartbot_ai_channels_modal_open',
  smartbotAIPaymentModalOpen = 'smartbot_ai_payment_modal_open',

  onboardingPageView = 'onboarding_page_view',
  onboardingOpenDocumentation = 'onboarding_open_documentation',
  onboardingOpenSupportChat = 'onboarding_open_support_chat',

  channelCreationOnOnboarding = 'channel_creation_on_onboarding',
  channelCreationAfterOnboarding = 'channel_creation_after_onboarding',
  scenarioCreationOnOnboarding = 'scenario_creation_on_onboarding',
  scenarioCreationAfterOnboarding = 'scenario_creation_after_onboarding',
  scenarioWithTemplateCreationOnOnboarding = 'scenario_with_template_creation_on_onboarding',

  onboardingIntroVideoStarted = 'onboarding_intro_video_started',
  onboardingIntroVideoCompleted = 'onboarding_intro_video_completed',
  onboardingAdvancedVideoStarted = 'onboarding_advanced_video_started',
  onboardingAdvancedVideo50Percent = 'onboarding_advanced_video_50_percent',
  onboardingAdvancedVideoCompleted = 'onboarding_advanced_video_completed',

  onboardingQuickStart = 'onboarding_quick_start',
  onboardingFinish = 'onboarding_finish',

  whatsAppExperimentClickPay = 'whatsapp_experiment_click_pay',
  creationChannelOpenForm = 'creation_channel_open_form',
  creationChannelViaJivoOpenForm = 'creation_channel_via_jivo_open_form',
  creationChannelViaWazzupOpenForm = 'creation_channel_via_wazzup_open_form'
}

export type AnalyticsPayload = Record<string, any>;

export type SendAnalyticsEvent = (
  event: AnalyticsEvent,
  payload?: AnalyticsPayload
) => void;

export type AnalyticsEventObj = {
  type: AnalyticsEvent;
  payload: AnalyticsPayload;
};

export type AnalyticsSecondaryType =
  `${typeof EVENT_PREFIX_FOR_SECONDARY_COUNTER}_${AnalyticsEvent}`;

export enum BalancePageViewTab {
  manageTariffs = 'manage_tariffs',
  info = 'info'
}
